module.exports = __webpack_public_path__ + "static/media/full-service-production-hero.8632ad41.png";